import { render, staticRenderFns } from "./EditInboundSettings.vue?vue&type=template&id=72df9ec4&scoped=true&"
import script from "./EditInboundSettings.vue?vue&type=script&lang=js&"
export * from "./EditInboundSettings.vue?vue&type=script&lang=js&"
import style0 from "./EditInboundSettings.vue?vue&type=style&index=0&id=72df9ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df9ec4",
  null
  
)

/* custom blocks */
import block0 from "./EditInboundSettings.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports